<template>
  <v-dialog
    ref="dialog"
    persistent
    v-model="modal"
    lazy
    full-width
    width="290px"
    :time.sync="selectedTime"
    :disabled="disabled"
  >
    <v-text-field
      slot="activator"
      :label="label"
      v-model="time"
      prepend-icon="access_time"
      :error-messages="errors"
      :disabled="disabled"
      readonly
    ></v-text-field>
    <v-time-picker v-model="selectedTime" scrollable>
      <v-spacer></v-spacer>
      <v-btn flat color="accent" @click="modal = false">Cancelar</v-btn>
      <v-btn depressed color="accent" @click="accept()">Aceptar</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  props: ['time', 'label', 'errors', 'disabled'],
  data () {
    return {
      selectedTime: this.time,
      modal: false
    }
  },
  methods: {
    accept () {
      this.$emit('update:time', this.selectedTime)
      this.modal = false
    }
  },
  watch: {
    time () {
      this.selectedTime = this.time
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/TimePicker.vue